import commonModule from "./ja/common";
import userModule from "./ja/user";
import loginModule from "./ja/login";
import registerModule from "./ja/register";
import questionModule from "./ja/question";
import statusModule from "./ja/status";
import codeModule from "./ja/errorCode";
import { storeModule, evaluationModule } from "./ja/store";
import { orderModule } from "./ja/order";
import { homeModule, searchModule } from "./ja/home";
import { otherModule } from "./ja/other";
import { goodsCouponModule } from "@/i18n/config/ja/goodsCoupon";
const zh = {
    commonBox: commonModule,
    loginBox: loginModule,
    registerBox: registerModule,
    questionBox: questionModule,
    //店铺详情
    storeDetail: storeModule,
    //评价部分
    evaluationBox: evaluationModule,
    orderModule: orderModule,
    //首页
    home: homeModule,
    searchModule: searchModule,
    userModule: userModule,
    //状态
    status: statusModule,
    //错误码
    errorCode: codeModule,
    //其它
    otherModule: otherModule,
    goodsCouponModule: goodsCouponModule,
};
export default zh;
